import { useQuery } from "@tanstack/react-query";
import { getCategoryMenu } from "src/api/categoryMenu";
import { useHomeSwitchStore } from "src/store/homeSwitch.store";
import { QUERY_KEYS } from "../constants/queryKeys";
const useGetCategoryMenu = ()=>{
    const { homeType  } = useHomeSwitchStore();
    return useQuery({
        queryKey: [
            QUERY_KEYS.CATEGORY_MENU,
            homeType
        ],
        queryFn: ()=>getCategoryMenu(homeType),
        staleTime: 1000 * 60 * 5
    });
};
export default useGetCategoryMenu;
